/**
 * Actor SDK エクスポート
 * Actor v3 プロセス代数 & LangChain.js互換性対応
 * https://actor.gftd.ai/api/v3/actor
 */

// === Actor v3 Types ===
export * from "./types/actor-v3"

// === Core Types (共通) ===
export * from "./types/config"
export * from "./types/session"
export * from "./types/chat-git"

// === LangChain Types (v3と重複しない型のみ) ===
export type {
  MessageLike,
  HumanMessage,
  AIMessage,
  SystemMessage,
  ToolMessage,
  ToolCall,
  StructuredTool,
  RunnableInput,
  InvokeRequest,
  StreamRequest,
  BatchRequest,
  InvokeResponse,
  BatchResponse,
  ErrorResponse
} from "./types/langchain"

// === Actor v3 API Client ===
export * from "./api/actor-v3-client"

// === Chat API Client ===
export * from "./api/chat-client"

// === Actor v3 React Hooks ===
export * from "../hooks/use-actor-v3"

// === Chat React Hooks ===
export * from "../hooks/use-gftd-chat"

// === Configuration ===
// export * from "./actor-sdk-config" // TODO: v3 migration - disabled temporarily
export * from "./config/sdk-config-manager"

// === Git Integration (共通) ===
export * from "./git/actor-git-manager"
export * from "./git/actor-repository-manager"
export * from "./git/chat-git-manager"
export * from "./git/chat-history-utils"
export * from "./git/git-embedding-sdk"
export * from "./git/git-fs"
export * from "./git/git-vector-store"
export * from "./git/gitlab-client"

// === Authentication (共通) ===
export * from "./auth/auth-middleware"
export * from "./auth/gftd-auth-client"

// === Embedding & Vector Store (共通) ===
export type { EmbeddingConfig as ActorEmbeddingConfig } from "./embedding"
export * from "./embedding/vector-store"

// === Utilities (共通) ===
export * from "./utils"
export * from "./utils/uuid"

// === Configuration Constants ===
export const SDK_VERSION = "3.0.0"
export const API_VERSION = "v3"
export const PROCESS_ALGEBRA_ENABLED = true

/**
 * Actor v3 機能フラグ
 */
export const Features = {
  PROCESS_ALGEBRA: true,
  LANGCHAIN_COMPATIBILITY: true,
  FORMAL_VERIFICATION: true,
  DEADLOCK_DETECTION: true,
  LIVELOCK_DETECTION: true,
  COMMUNICATION_TOPOLOGY: true,
  PERFORMANCE_METRICS: true
} as const

/**
 * Process Algebra Support
 */
export const ProcessAlgebra = {
  NOTATIONS: ['CCS', 'π-calculus', 'ACP'] as const,
  ANALYSIS_FEATURES: ['deadlock_detection', 'livelock_detection', 'reachability_analysis'] as const,
  COMMUNICATION_PATTERNS: ['send_receive', 'parallel_composition', 'choice', 'recursion'] as const
} as const

/**
 * LangChain.js 互換性サポート
 */
export const LangChainCompatibility = {
  RUNNABLE_INTERFACE: true,
  INVOKE_METHOD: true,
  STREAM_METHOD: true,
  BATCH_METHOD: true,
  PIPE_METHOD: true,
  FALLBACK_METHOD: true
} as const 